"use strict";

/**
 * 指定された要素数を配列からランダムに取り出し新しい配列として返却します。
 * @module hello
 * @param {string[]} array - 要素を取り出したい配列
 * @param {number} num - 取り出したいの数
 * @return {string[]} - ランダムに要素を取り出した配列
 */
const getRandomSelect = (array, num) => {
  let newArray = [];

  while (newArray.length < num && array.length > 0) {
    const rand = Math.floor(Math.random() * array.length);
    newArray.push(array[rand]);
    array.splice(rand, 1);
  }

  return newArray;
};

export { getRandomSelect };
